(function () {
  'use strict';

  var API_BASE = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net';
  var EVENT_ENDPOINT = API_BASE + '/portalPublicPartnerStoryEventV1';
  var SEEN_KEY = 'florame_partner_stories_seen_v1';
  var IMAGE_DURATION = 6000;
  var RELATIVE_TIME_REFRESH_MS = 60 * 1000;
  var relativeTimeBindings = [];
  var relativeTimeTimer = 0;

  function safeJson(value, fallback) {
    try { return JSON.parse(value); } catch (_) { return fallback; }
  }

  // An event registry keeps generated artwork separate from shop identity and copy.
  function artworkFor(story, group) {
    if (story.source !== 'florame' || story.mediaType === 'video' || story.motionVersion) return null;
    var registry = document.getElementById('florame-story-artwork');
    var catalog = registry ? safeJson(registry.textContent, {}) : {};
    var choices = catalog.schemaVersion === 1 && catalog.events && catalog.events[story.kind];
    if (!Array.isArray(choices) || !choices.length) return null;
    var key = String(group.partnerId || group.partnerSlug || '') + ':' + String(story.storyId || story.createdAt || '');
    var hash = 2166136261;
    for (var index = 0; index < key.length; index++) hash = Math.imul(hash ^ key.charCodeAt(index), 16777619) >>> 0;
    var artwork = choices[hash % choices.length];
    if (!artwork || !artwork.imageUrl || !artwork.logo) return null;
    var logo = artwork.logo;
    if (![logo.x, logo.y, logo.diameter].every(function (value) { return Number.isFinite(value) && value > 0 && value < 100; })) return null;
    return artwork;
  }

  function readSeen() {
    try {
      var values = safeJson(window.localStorage.getItem(SEEN_KEY) || '{}', {});
      var cutoff = Date.now() - (48 * 60 * 60 * 1000);
      Object.keys(values).forEach(function (key) {
        if (Number(values[key] || 0) < cutoff) delete values[key];
      });
      return values;
    } catch (_) { return {}; }
  }

  function writeSeen(seen) {
    try { window.localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch (_) {}
  }

  function initials(name) {
    return String(name || 'F').trim().split(/\s+/).slice(0, 2).map(function (part) { return part.charAt(0); }).join('').toUpperCase() || 'F';
  }

  function relativeTime(value) {
    var ms = new Date(value || 0).getTime();
    if (!ms) return 'nelle ultime 24 ore';
    var minutes = Math.max(0, Math.floor((Date.now() - ms) / 60000));
    if (minutes < 2) return 'adesso';
    if (minutes < 60) return minutes + ' min fa';
    var hours = Math.floor(minutes / 60);
    return hours === 1 ? '1 ora fa' : hours + ' ore fa';
  }

  function latestGroupTimestamp(group) {
    var values = [group && group.latestAt].concat(
      Array.isArray(group && group.stories)
        ? group.stories.map(function (story) { return story && story.createdAt; })
        : []
    );
    return values.reduce(function (latest, value) {
      var parsed = new Date(value || 0).getTime();
      return Number.isFinite(parsed) && parsed > latest ? parsed : latest;
    }, 0);
  }

  function compactRelativeTime(value) {
    var timestamp = Number(value || 0);
    if (!Number.isFinite(timestamp) || timestamp <= 0) return '2h fa';
    var minutes = Math.max(1, Math.floor((Date.now() - timestamp) / 60000));
    if (minutes < 60) return minutes + 'm fa';
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + 'h fa';
    return Math.max(1, Math.floor(hours / 24)) + 'g fa';
  }

  function refreshRelativeTimeBindings() {
    relativeTimeBindings = relativeTimeBindings.filter(function (binding) {
      if (!binding.node || !binding.node.isConnected) return false;
      var label = compactRelativeTime(binding.timestamp);
      binding.node.textContent = label;
      if (typeof binding.onChange === 'function') binding.onChange(label);
      return true;
    });
    if (!relativeTimeBindings.length && relativeTimeTimer) {
      window.clearInterval(relativeTimeTimer);
      relativeTimeTimer = 0;
    }
  }

  function bindRelativeTime(node, value, onChange) {
    if (!node) return;
    var timestamp = Number(value || 0);
    var label = compactRelativeTime(timestamp);
    node.textContent = label;
    if (typeof onChange === 'function') onChange(label);
    relativeTimeBindings.push({ node: node, timestamp: timestamp, onChange: onChange });
    if (!relativeTimeTimer) {
      relativeTimeTimer = window.setInterval(refreshRelativeTimeBindings, RELATIVE_TIME_REFRESH_MS);
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  var logoObserver;
  function loadLogoWhenNear(image, url) {
    if (!('IntersectionObserver' in window)) { image.src = url; return; }
    if (!logoObserver) logoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.target.isConnected) { logoObserver.unobserve(entry.target); return; }
        if (!entry.isIntersecting) return;
        var image = entry.target;
        image.src = image.dataset.storyLogo;
        delete image.dataset.storyLogo;
        logoObserver.unobserve(image);
      });
    }, {rootMargin: '80px 40px'});
    image.dataset.storyLogo = url;
    logoObserver.observe(image);
  }

  function avatarNode(group, className) {
    var avatar = element('span', className);
    if (group.logoUrl) {
      var image = document.createElement('img');
      image.style.visibility = 'hidden';
      image.addEventListener('load', function () { image.style.visibility = ''; }, {once:true});
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 512;
      image.height = 512;
      image.addEventListener('error', function () {
        image.remove();
        avatar.textContent = initials(group.partnerName);
      }, { once: true });
      avatar.appendChild(image);
      loadLogoWhenNear(image, group.logoUrl);
    } else {
      avatar.textContent = initials(group.partnerName);
    }
    return avatar;
  }

  function track(story, eventName) {
    if (!story || !story.storyId || String(story.storyId).indexOf('recent_') === 0) return;
    var payload = JSON.stringify({ storyId: story.storyId, event: eventName });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(EVENT_ENDPOINT, new Blob([payload], { type: 'application/json' }));
        return;
      }
    } catch (_) {}
    fetch(EVENT_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(function () {});
  }

  function createViewer(groups, seen, onSeenChange) {
    var viewer = element('div', 'florame-story-viewer');
    viewer.hidden = true;
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Stories dei fioristi Florame');

    var stage = element('div', 'florame-story-viewer__stage');
    var media = element('div', 'florame-story-viewer__media');
    var chrome = element('div', 'florame-story-viewer__chrome');
    var progress = element('div', 'florame-story-viewer__progress');
    var header = element('div', 'florame-story-viewer__header');
    var identity = element('div', 'florame-story-viewer__identity');
    var name = element('strong', '', 'Fiorista Florame');
    var meta = element('span', '', 'Attività Florame');
    identity.appendChild(name);
    identity.appendChild(meta);
    var closeButton = element('button', 'florame-story-viewer__close');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Chiudi le Stories');
    closeButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"></path></svg>';
    var copy = element('div', 'florame-story-viewer__copy');
    var source = element('span', 'florame-story-viewer__source');
    var title = element('h2');
    var body = element('p');
    var cta = element('a', 'florame-story-viewer__cta');
    var productLink = element('a', 'florame-story-viewer__product-link');
    productLink.hidden = true;
    productLink.setAttribute('aria-label', 'Ordina ora: apri il prodotto');
    var editorialPlane = element('div', 'florame-story-viewer__editorial-plane');
    editorialPlane.appendChild(productLink);
    copy.appendChild(source);
    copy.appendChild(title);
    copy.appendChild(body);
    copy.appendChild(cta);
    var previous = element('button', 'florame-story-viewer__tap florame-story-viewer__tap--prev', 'Story precedente');
    var next = element('button', 'florame-story-viewer__tap florame-story-viewer__tap--next', 'Story successiva');
    previous.type = next.type = 'button';
    header.appendChild(identity);
    var sound = element('button', 'florame-story-viewer__sound', 'Audio');
    sound.type = 'button'; sound.hidden = true; sound.setAttribute('aria-label', 'Attiva audio'); sound.setAttribute('aria-pressed', 'false');
    header.appendChild(sound);
    header.appendChild(closeButton);
    chrome.appendChild(progress);
    chrome.appendChild(header);
    stage.appendChild(media);
    stage.appendChild(previous);
    stage.appendChild(next);
    stage.appendChild(copy);
    stage.appendChild(editorialPlane);
    stage.appendChild(chrome);
    viewer.appendChild(stage);
    document.body.appendChild(viewer);
    // Same 9:16 coordinate space as the exported artwork, even with letterboxing.
    new ResizeObserver(function () {
      var width = Math.min(stage.clientWidth, stage.clientHeight * 9 / 16);
      editorialPlane.style.width = width + 'px';
      editorialPlane.style.height = width * 16 / 9 + 'px';
    }).observe(stage);

    var groupIndex = 0;
    var storyIndex = 0;
    var timer = 0;
    var startedAt = 0;
    var remaining = IMAGE_DURATION;
    var currentVideo = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var holdTimer = 0;
    var lastFocus = null;
    var closeTimer = 0;
    var openFrame = 0;
    var videoCache = new Map(), imageCache = new Map(), mediaCleanup = function () {};

    function startTime(story) {
      if (story.source !== 'florame') return 0;
      return story.kind === 'availability_update' && story.motionVersion ? .5 : ['product', 'completed_order'].indexOf(story.kind) !== -1 ? 1.15 : 0;
    }
    function warmImage(url) {
      if (!url || imageCache.has(url)) return;
      var image = new Image(); image.decoding = 'async'; image.src = url;
      imageCache.set(url, image);
      if (imageCache.size > 12) imageCache.delete(imageCache.keys().next().value);
    }
    function preparedVideo(story) {
      var video = videoCache.get(story.mediaUrl);
      if (video && video.error) { videoCache.delete(story.mediaUrl); video = null; }
      if (!video) {
        video = document.createElement('video'); video.playsInline = true; video.muted = true; video.preload = 'auto';
        video.poster = story.thumbnailUrl || ''; video.src = story.mediaUrl;
      }
      videoCache.delete(story.mediaUrl); videoCache.set(story.mediaUrl, video);
      videoCache.forEach(function (candidate, url) {
        if (videoCache.size > 3 && !candidate.isConnected) {
          candidate.pause(); candidate.removeAttribute('src'); candidate.load(); videoCache.delete(url);
        }
      });
      return video;
    }
    function warm(nextGroupIndex, nextStoryIndex, imagesOnly) {
      var group = groups[nextGroupIndex]; if (!group) return;
      var index = Number.isInteger(nextStoryIndex) ? nextStoryIndex : group.stories.findIndex(function (story) { return !seen[story.storyId]; });
      var story = group.stories[Math.max(0, index)]; if (!story) return;
      var artwork = artworkFor(story, group);
      warmImage(artwork ? artwork.imageUrl : story.thumbnailUrl);
      if (story.mediaType !== 'video') warmImage(story.mediaUrl);
      else if (!imagesOnly && !(navigator.connection && navigator.connection.saveData)) preparedVideo(story);
    }

    function currentGroup() { return groups[groupIndex] || groups[0]; }
    function currentStory() { return currentGroup() && currentGroup().stories[storyIndex]; }

    function clearTimer() {
      mediaCleanup(); mediaCleanup = function () {};
      if (timer) window.clearTimeout(timer);
      timer = 0;
      if (currentVideo) {
        try { currentVideo.pause(); } catch (_) {}
        currentVideo = null;
      }
    }

    function schedule(duration) {
      if (timer) window.clearTimeout(timer);
      remaining = Math.max(800, Number(duration || IMAGE_DURATION));
      startedAt = Date.now();
      timer = viewer.classList.contains('is-paused') ? 0 : window.setTimeout(showNext, remaining);
    }

    function pause() {
      if (viewer.hidden || viewer.classList.contains('is-paused')) return;
      viewer.classList.add('is-paused');
      if (timer) {
        remaining = Math.max(250, remaining - (Date.now() - startedAt));
        window.clearTimeout(timer);
        timer = 0;
      }
      if (currentVideo) currentVideo.pause();
    }

    function resume() {
      if (viewer.hidden || !viewer.classList.contains('is-paused')) return;
      viewer.classList.remove('is-paused');
      if (currentVideo) {
        currentVideo.play().catch(function () {});
      }
      startedAt = Date.now();
      if (!stage.classList.contains('is-buffering')) timer = window.setTimeout(showNext, remaining);
    }

    function renderProgress(group) {
      progress.replaceChildren();
      group.stories.forEach(function (_, index) {
        var bar = element('span');
        var fill = element('i');
        if (index < storyIndex) bar.classList.add('is-complete');
        if (index === storyIndex) bar.classList.add('is-current');
        bar.appendChild(fill);
        progress.appendChild(bar);
      });
    }

    function renderMedia(story, group) {
      media.replaceChildren();
      currentVideo = null;
      stage.classList.add('is-buffering');
      function visible() { stage.classList.remove('is-buffering'); }
      sound.hidden = story.mediaType !== 'video' || (story.kind === 'availability_update' && Boolean(story.motionVersion));sound.setAttribute('aria-pressed', 'false');sound.setAttribute('aria-label', 'Attiva audio');
      var artwork = artworkFor(story, group);
      stage.classList.toggle('is-artwork', Boolean(artwork));
      if (artwork) {
        stage.style.setProperty('--story-surface', artwork.surface || '#fff0f4');
        var canvas = element('div', 'florame-story-artwork');
        canvas.dataset.artworkId = artwork.id;
        canvas.style.setProperty('--logo-x', artwork.logo.x + '%');
        canvas.style.setProperty('--logo-y', artwork.logo.y + '%');
        canvas.style.setProperty('--logo-diameter', artwork.logo.diameter + '%');
        var background = document.createElement('img');
        background.className = 'florame-story-artwork__background';
        background.alt = '';
        background.width = 1080;
        background.height = 1920;
        background.decoding = 'async';
        var logo = element('div', 'florame-story-artwork__logo');
        var monogram = element('span', '', initials(group.partnerName));
        logo.appendChild(monogram);
        var logoUrl = group.logoUrl || story.logoUrl;
        if (logoUrl) {
          var shopLogo = document.createElement('img');
          shopLogo.alt = group.partnerName || 'Logo del fiorista';
          shopLogo.decoding = 'async';
          shopLogo.addEventListener('load', function () { monogram.hidden = true; }, { once: true });
          shopLogo.addEventListener('error', function () { shopLogo.remove(); }, { once: true });
          shopLogo.src = logoUrl;
          logo.appendChild(shopLogo);
        }
        background.addEventListener('error', function () {
          if (media.contains(canvas)) showFallback(group);
        }, { once: true });
        background.src = artwork.imageUrl;
        canvas.appendChild(background);
        canvas.appendChild(logo);
        media.appendChild(canvas);
        background.addEventListener('load', function () { if (media.contains(canvas)) { visible(); schedule(IMAGE_DURATION); } }, { once: true });
        if (background.complete && background.naturalWidth) { visible(); schedule(IMAGE_DURATION); }
        progress.style.setProperty('--story-duration', IMAGE_DURATION + 'ms');
        return;
      }
      var url = story.mediaUrl || story.thumbnailUrl || group.logoUrl || '';
      if (!url) {
        var fallback = element('div', 'florame-story-viewer__fallback');
        fallback.style.setProperty('--story-accent', group.accentColor || '#e31b5d');
        fallback.appendChild(element('span', '', initials(group.partnerName)));
        media.appendChild(fallback);
        visible();
        schedule(IMAGE_DURATION);
        return;
      }
      if (story.mediaType === 'video') {
        var poster;
        if (story.thumbnailUrl) { poster = document.createElement('img'); poster.src = story.thumbnailUrl; poster.alt = ''; poster.className = 'florame-story-video-poster'; }
        else { poster = element('div', 'florame-story-viewer__fallback'); poster.appendChild(element('span', '', initials(group.partnerName))); }
        media.appendChild(poster);
        var video = preparedVideo(story), frame = 0;
        video.style.opacity = '0'; video.muted = true;
        function reveal() { if (media.contains(video) && !viewer.hidden && !video.seeking) { video.style.opacity = '1'; poster.remove(); } }
        function playing() {
          if (!media.contains(video) || viewer.hidden || viewer.classList.contains('is-paused')) return;
          visible();
          var duration = Math.min(60000, Math.max(800, (Number(video.duration || 6) - video.currentTime) * 1000));
          progress.style.setProperty('--story-duration', duration + 'ms'); schedule(duration);
          if (video.requestVideoFrameCallback) frame = video.requestVideoFrameCallback(reveal); else reveal();
        }
        function waiting() { if (media.contains(video)) { stage.classList.add('is-buffering'); if (timer) window.clearTimeout(timer); timer = 0; } }
        function failed() { if (media.contains(video)) { if (poster) { video.remove(); currentVideo = null; visible(); sound.hidden = true; schedule(IMAGE_DURATION); } else showFallback(group); } }
        function ended() { if (media.contains(video) && !viewer.hidden) showNext(); }
        function start() {
          if (!media.contains(video) || viewer.hidden) return;
          try { video.currentTime = Math.min(startTime(story), Math.max(0, (video.duration || Infinity) - .1)); } catch (_) {}
          if (!viewer.classList.contains('is-paused')) video.play().catch(function () { if (media.contains(video)) { video.controls = true; video.style.opacity = '1'; visible(); } });
        }
        video.addEventListener('playing', playing); video.addEventListener('waiting', waiting); video.addEventListener('error', failed); video.addEventListener('ended', ended);
        mediaCleanup = function () { video.removeEventListener('playing', playing); video.removeEventListener('waiting', waiting); video.removeEventListener('error', failed); video.removeEventListener('ended', ended); video.removeEventListener('loadedmetadata', start); if (frame && video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frame); video.controls = false; };
        media.appendChild(video);
        currentVideo = video;
        if (video.readyState >= 1) start(); else video.addEventListener('loadedmetadata', start, { once: true });
      } else {
        var thumbnail;
        if (story.thumbnailUrl && story.thumbnailUrl !== url) { thumbnail = document.createElement('img'); thumbnail.src = story.thumbnailUrl; thumbnail.alt = ''; thumbnail.className = 'florame-story-video-poster'; media.appendChild(thumbnail); }
        else if (!imageCache.get(url)?.naturalWidth) { thumbnail = element('div', 'florame-story-viewer__fallback'); thumbnail.appendChild(element('span', '', initials(group.partnerName))); media.appendChild(thumbnail); }
        var image = document.createElement('img');
        image.alt = '';
        image.decoding = 'async';
        image.style.opacity = '0';
        function imageReady() {
          var decoded = image.decode ? image.decode().catch(function () {}) : Promise.resolve();
          decoded.then(function () { if (media.contains(image)) { image.style.opacity = '1'; if (thumbnail) thumbnail.remove(); visible(); schedule(IMAGE_DURATION); } });
        }
        image.addEventListener('load', imageReady, { once: true });
        image.addEventListener('error', function () { if (media.contains(image)) showFallback(group); }, { once: true });
        image.src = url;
        media.appendChild(image);
        progress.style.setProperty('--story-duration', IMAGE_DURATION + 'ms');
        if (image.complete && image.naturalWidth) imageReady();
      }
    }

    function showFallback(group) {
      clearTimer();
      stage.classList.remove('is-buffering');
      stage.classList.remove('is-artwork');
      stage.classList.remove('is-editorial');productLink.hidden = true;copy.hidden = false;sound.hidden = true;
      media.replaceChildren();
      var fallback = element('div', 'florame-story-viewer__fallback');
      fallback.style.setProperty('--story-accent', group.accentColor || '#e31b5d');
      fallback.appendChild(element('span', '', initials(group.partnerName)));
      media.appendChild(fallback);
      schedule(IMAGE_DURATION);
    }

    function render() {
      clearTimer();
      var group = currentGroup();
      var story = currentStory();
      if (!group || !story) return close();
      viewer.classList.remove('is-paused');
      stage.style.setProperty('--story-accent', group.accentColor || '#e31b5d');
      renderProgress(group);
      var existingAvatar = header.querySelector('.florame-story-viewer__avatar');
      if (existingAvatar) existingAvatar.remove();
      header.insertBefore(avatarNode(group, 'florame-story-viewer__avatar'), identity);
      name.textContent = group.partnerName || 'Fiorista Florame';
      meta.textContent = (story.sourceLabel || 'Attività Florame') + ' · ' + relativeTime(story.createdAt);
      source.textContent = story.badge || story.sourceLabel || 'Attività Florame';
      title.textContent = story.title || 'Novità dal fiorista';
      body.textContent = story.body || 'Scopri cosa sta succedendo in negozio.';
      cta.textContent = story.ctaLabel || 'Scopri i bouquet';
      cta.href = story.ctaUrl || (group.partnerSlug ? '/pages/' + group.partnerSlug : '/');
      cta.onclick = function () { track(story, 'cta'); };
      var availabilityMotion = story.source === 'florame' && story.kind === 'availability_update' && Boolean(story.motionVersion);
      var editorial = story.source === 'florame' && (['product', 'completed_order'].indexOf(story.kind) !== -1 || availabilityMotion);
      stage.classList.toggle('is-availability-motion', availabilityMotion);
      stage.classList.toggle('is-editorial', editorial);
      productLink.hidden = !editorial || (story.kind !== 'product' && !availabilityMotion) || !story.ctaUrl;
      productLink.setAttribute('aria-label', availabilityMotion ? 'Crea il tuo bouquet' : 'Ordina ora: apri il prodotto');
      // Reuse the server-derived, florist-scoped product link; never a checkout URL.
      productLink.href = cta.href;
      productLink.onclick = function (event) { event.stopPropagation(); track(story, 'cta'); };
      copy.hidden = editorial;
      seen[story.storyId] = Date.now();
      writeSeen(seen);
      onSeenChange();
      track(story, 'open');
      renderMedia(story, group);
      // Just the next story; no unbounded downloads or additional API reads.
      warm(groupIndex, storyIndex + 1);
    }

    function open(nextGroupIndex, nextStoryIndex) {
      if (closeTimer) window.clearTimeout(closeTimer);
      if (openFrame) window.cancelAnimationFrame(openFrame);
      closeTimer = 0;
      groupIndex = Math.max(0, Math.min(groups.length - 1, Number(nextGroupIndex || 0)));
      var group = currentGroup();
      var firstUnseen = group.stories.findIndex(function (story) { return !seen[story.storyId]; });
      storyIndex = Number.isInteger(nextStoryIndex) ? nextStoryIndex : (firstUnseen >= 0 ? firstUnseen : 0);
      lastFocus = document.activeElement;
      viewer.hidden = false;
      document.body.classList.add('florame-story-is-open');
      openFrame = window.requestAnimationFrame(function () { openFrame = 0; viewer.classList.add('is-open'); });
      render();
      closeButton.focus({ preventScroll: true });
    }

    function close() {
      if (viewer.hidden) return;
      if (openFrame) window.cancelAnimationFrame(openFrame);
      if (closeTimer) window.clearTimeout(closeTimer);
      openFrame = 0;
      clearTimer();
      videoCache.forEach(function (video) { video.pause(); video.removeAttribute('src'); video.load(); });
      videoCache.clear();
      imageCache.forEach(function (image) { image.removeAttribute('src'); });
      imageCache.clear();
      viewer.classList.remove('is-open', 'is-paused');
      document.body.classList.remove('florame-story-is-open');
      closeTimer = window.setTimeout(function () { closeTimer = 0; viewer.hidden = true; media.replaceChildren(); }, 210);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function showNext() {
      var group = currentGroup();
      var story = currentStory();
      if (story) track(story, 'complete');
      if (storyIndex < group.stories.length - 1) storyIndex += 1;
      else if (groupIndex < groups.length - 1) { groupIndex += 1; storyIndex = 0; }
      else return close();
      render();
    }

    function showPrevious() {
      if (storyIndex > 0) storyIndex -= 1;
      else if (groupIndex > 0) { groupIndex -= 1; storyIndex = Math.max(0, currentGroup().stories.length - 1); }
      else storyIndex = 0;
      render();
    }

    closeButton.addEventListener('click', close);
    sound.addEventListener('click', function () {
      if (!currentVideo) return;
      currentVideo.muted = !currentVideo.muted;
      sound.setAttribute('aria-pressed', String(!currentVideo.muted));
      sound.setAttribute('aria-label', currentVideo.muted ? 'Attiva audio' : 'Disattiva audio');
    });
    next.addEventListener('click', showNext);
    previous.addEventListener('click', showPrevious);
    stage.addEventListener('pointerdown', function (event) {
      if (event.target.closest('a,.florame-story-viewer__sound')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      touchStartX = event.clientX;
      touchStartY = event.clientY;
      if (holdTimer) window.clearTimeout(holdTimer);
      holdTimer = window.setTimeout(pause, 160);
    });
    stage.addEventListener('pointerup', function (event) {
      if (event.target.closest('a,.florame-story-viewer__sound')) return;
      if (holdTimer) window.clearTimeout(holdTimer);
      holdTimer = 0;
      var dx = event.clientX - touchStartX;
      var dy = event.clientY - touchStartY;
      resume();
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) dx < 0 ? showNext() : showPrevious();
      if (dy > 95 && Math.abs(dy) > Math.abs(dx)) close();
    });
    stage.addEventListener('pointercancel', function () {
      if (holdTimer) window.clearTimeout(holdTimer);
      holdTimer = 0;
      resume();
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? pause() : resume(); });
    document.addEventListener('keydown', function (event) {
      if (viewer.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') showNext();
      if (event.key === 'ArrowLeft') showPrevious();
      if (event.key === ' ' && !/a|button/i.test(document.activeElement && document.activeElement.tagName)) {
        event.preventDefault();
        viewer.classList.contains('is-paused') ? resume() : pause();
      }
    });

    return { open: open, close: close, warm: warm };
  }

  function renderRail(root, groups) {
    var rail = root.querySelector('[data-stories-rail]');
    if (!rail || !groups.length) return;
    rail.replaceChildren();
    var seen = readSeen();
    var buttons = [];
    var groupIndexBySlug = new Map();

    function allSeen(group) {
      return group.stories.every(function (story) { return !!seen[story.storyId]; });
    }

    function updateCardLogoStates() {
      document.querySelectorAll('[data-marketplace-partner-card][data-partner-slug]').forEach(function (card) {
        var index = groupIndexBySlug.get(String(card.getAttribute('data-partner-slug') || ''));
        var logo = card.querySelector('[data-marketplace-partner-logo]');
        if (!logo || index == null) return;
        // Hub saves the centered logo in the asset itself. Reuse the current
        // card URL (and browser cache), rather than the Story's old snapshot.
        var logoImage = logo.querySelector('img');
        var logoUrl = logoImage && logoImage.getAttribute('src');
        if (logoUrl && groups[index].logoUrl !== logoUrl) {
          groups[index].logoUrl = logoUrl;
          var avatar = buttons[index].querySelector('.florame-story-bubble__avatar');
          avatar.replaceWith(avatarNode(groups[index], 'florame-story-bubble__avatar'));
        }
        logo.classList.toggle('is-seen', allSeen(groups[index]));
      });
    }

    function updateSeenStates() {
      groups.forEach(function (group, index) {
        if (buttons[index]) buttons[index].classList.toggle('is-seen', allSeen(group));
      });
      updateCardLogoStates();
    }
    var viewer = createViewer(groups, seen, updateSeenStates);
    groups.forEach(function (group, index) {
      if (group.partnerSlug) groupIndexBySlug.set(String(group.partnerSlug), index);
      var button = element('button', 'florame-story-bubble');
      button.type = 'button';
      button.style.setProperty('--story-accent', group.accentColor || '#e31b5d');
      var partnerName = group.partnerName || 'questo fiorista';
      button.setAttribute('aria-label', 'Apri le Stories di ' + partnerName);
      var ring = element('span', 'florame-story-bubble__ring');
      ring.appendChild(avatarNode(group, 'florame-story-bubble__avatar'));
      var ageBadge = element('span', 'florame-story-bubble__live');
      bindRelativeTime(ageBadge, latestGroupTimestamp(group), function (label) {
        button.setAttribute('aria-label', 'Attività ' + label + '. Apri le Stories di ' + partnerName);
      });
      ring.appendChild(ageBadge);
      button.appendChild(ring);
      button.appendChild(element('span', 'florame-story-bubble__label', group.partnerName || 'Fiorista'));
      button.addEventListener('click', function () { viewer.open(index); });
      ['pointerenter', 'focus', 'pointerdown'].forEach(function (event) { button.addEventListener(event, function () { viewer.warm(index, undefined, true); }, { passive: true }); });
      rail.appendChild(button);
      buttons.push(button);
    });

    function decoratePartnerCards() {
      document.querySelectorAll('[data-marketplace-partner-card][data-partner-slug]').forEach(function (card) {
        var slug = String(card.getAttribute('data-partner-slug') || '');
        var index = groupIndexBySlug.get(slug);
        var logo = card.querySelector('[data-marketplace-partner-logo]');
        if (!logo || index == null) return;
        logo.classList.add('has-stories');
        logo.style.setProperty('--story-accent', groups[index].accentColor || '#e31b5d');
        logo.setAttribute('role', 'button');
        logo.setAttribute('tabindex', '0');
        logo.setAttribute('aria-label', 'Apri le Stories di ' + (groups[index].partnerName || 'questo fiorista'));
        logo.classList.toggle('is-seen', allSeen(groups[index]));
        if (logo.dataset.storiesBound === 'true') return;
        logo.dataset.storiesBound = 'true';
        logo.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          viewer.open(index);
        });
        logo.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          viewer.open(index);
        });
      });
    }

    decoratePartnerCards();
    document.addEventListener('florame:marketplace-partners-rendered', decoratePartnerCards);
    updateSeenStates();
    root.hidden = false;
    root.classList.toggle('is-single', groups.length === 1);
    root.classList.remove('is-loading', 'is-empty');
    root.classList.add('is-ready');
    root.setAttribute('aria-busy', 'false');
  }

  function renderProfileTrigger(root, groups) {
    var seen = readSeen();
    var trigger = null;
    var observer = null;
    var observerTimeout = 0;
    var group = groups[0];
    var viewer = createViewer(groups, seen, updateSeenState);
    var ageLabel = compactRelativeTime(latestGroupTimestamp(group));

    function updateSeenState() {
      if (!trigger) return;
      var allSeen = group.stories.every(function (story) { return !!seen[story.storyId]; });
      trigger.classList.toggle('is-seen', allSeen);
      trigger.setAttribute('aria-label', 'Attività ' + ageLabel + '. ' + (allSeen ? 'Rivedi' : 'Apri') + ' le Stories di ' + (group.partnerName || 'questo fiorista'));
    }

    function attach() {
      var logoRow = document.querySelector('.florame-partner-identity-row--editorial .florame-partner-logos-row');
      if (!logoRow) return false;
      var currentTrigger = logoRow.querySelector('[data-partner-story-trigger]');
      if (currentTrigger) {
        trigger = currentTrigger;
        updateSeenState();
        return true;
      }
      var logo = logoRow.querySelector('.florame-partner-logo');
      if (!logo) return false;
      if (logo.getAttribute('src')) group.logoUrl = logo.getAttribute('src');

      trigger = element('button', 'florame-partner-story-logo');
      trigger.type = 'button';
      trigger.setAttribute('data-partner-story-trigger', '');
      trigger.style.setProperty('--story-accent', group.accentColor || '#e31b5d');
      logo.replaceWith(trigger);
      trigger.appendChild(logo);
      var ageBadge = element('span', 'florame-partner-story-logo__badge');
      bindRelativeTime(ageBadge, latestGroupTimestamp(group), function (label) {
        ageLabel = label;
        updateSeenState();
      });
      trigger.appendChild(ageBadge);
      trigger.addEventListener('click', function () { viewer.open(0); });
      ['pointerenter', 'focus', 'pointerdown'].forEach(function (event) { trigger.addEventListener(event, function () { viewer.warm(0, undefined, true); }, { passive: true }); });
      updateSeenState();
      return true;
    }

    attach();
    observer = new MutationObserver(function () { attach(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    observerTimeout = window.setTimeout(function () {
      if (observer) observer.disconnect();
      observer = null;
    }, 30000);
    window.addEventListener('pagehide', function () {
      if (observer) observer.disconnect();
      if (observerTimeout) window.clearTimeout(observerTimeout);
    }, { once: true });
    root.setAttribute('aria-busy', 'false');
  }

  function loadStories(root) {
    var endpoint = root.getAttribute('data-stories-endpoint') || (API_BASE + '/portalPublicPartnerStoriesV1');
    var slug = root.getAttribute('data-partner-slug') || '';
    var url = new URL(endpoint);
    if (slug) url.searchParams.set('partnerSlug', slug);
    return fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('stories_http_' + response.status); return response.json(); })
      .then(function (payload) {
        var groups = Array.isArray(payload && payload.groups) ? payload.groups.filter(function (group) { return Array.isArray(group.stories) && group.stories.length; }) : [];
        if (groups.length) {
          if (root.getAttribute('data-stories-surface') === 'profile') renderProfileTrigger(root, groups);
          else renderRail(root, groups);
        }
        else {
          root.classList.remove('is-loading');
          root.classList.add('is-empty');
          root.setAttribute('aria-busy', 'false');
          root.hidden = true;
        }
        root.removeAttribute('data-stories-deferred');
      })
      .catch(function () {
        root.classList.remove('is-loading');
        root.classList.add('is-empty');
        root.setAttribute('aria-busy', 'false');
        root.hidden = true;
        root.removeAttribute('data-stories-deferred');
      });
  }

  function init() {
    if (document.documentElement.hasAttribute('data-florame-bouquet-collection')) return;
    document.querySelectorAll('[data-florame-stories]').forEach(function (root) {
      // Profile metadata decorates the existing visible shop logo; its hidden
      // data carrier cannot itself intersect. Home rails wait near the viewport.
      if (root.getAttribute('data-stories-surface') === 'profile' || !('IntersectionObserver' in window)) return loadStories(root);
      var started = false, finished = false;
      var scope = root.closest('main') || document;
      function observeLogos() {
        if (finished) return;
        scope.querySelectorAll('[data-marketplace-partner-card] [data-marketplace-partner-logo]').forEach(function (logo) { observer.observe(logo); });
      }
      function complete() { finished = true; observer.disconnect(); document.removeEventListener('florame:marketplace-partners-rendered', observeLogos); }
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.target === root && entry.isIntersecting; })) root.removeAttribute('data-stories-deferred');
        if (started || !entries.some(function (entry) { return entry.isIntersecting; })) return;
        // A visible florist logo is also a Story entry point. Preserve its
        // activity ring without warming the hidden rail's media or avatars.
        started = true; loadStories(root).finally(complete);
      }, {rootMargin:'160px 0px'});
      observer.observe(root);
      observeLogos();
      document.addEventListener('florame:marketplace-partners-rendered', observeLogos);
      window.addEventListener('pagehide', function () { observer.disconnect(); });
      window.addEventListener('pageshow', function (event) { if (event.persisted && !finished) { observer.observe(root); observeLogos(); } });
    });
    window.addEventListener('pagehide', function () {
      if (relativeTimeTimer) window.clearInterval(relativeTimeTimer);
      relativeTimeTimer = 0;
      relativeTimeBindings = [];
    }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
